import { WaterQualityData } from '../types/waterQuality';

// Sample water quality data for testing UI components
export const sampleWaterQuality: WaterQualityData = {
  id: '1',
  name: 'Tap Water Sample',
  ph: 6.8,
  ec: 0.45,
  tds: 225,
  temperature: 20,
  alkalinity: 95,
  ca: 35,
  mg: 12,
  k: 3,
  na: 15,
  cl: 25,
  so4: 18,
  no3: 5,
  hco3: 110,
  co3: 0,
  createdAt: new Date('2025-05-20T12:00:00Z'),
  updatedAt: new Date('2025-05-20T12:00:00Z')
};

// Hard water sample
export const hardWaterSample: WaterQualityData = {
  id: '2',
  name: 'Hard Well Water',
  ph: 7.5,
  ec: 0.85,
  tds: 425,
  temperature: 18,
  alkalinity: 210,
  ca: 95,
  mg: 38,
  k: 4,
  na: 26,
  cl: 48,
  so4: 65,
  no3: 3,
  hco3: 245,
  co3: 5,
  createdAt: new Date('2025-05-15T10:30:00Z'),
  updatedAt: new Date('2025-05-15T10:30:00Z')
};

// Soft water sample
export const softWaterSample: WaterQualityData = {
  id: '3',
  name: 'Rainwater',
  ph: 5.9,
  ec: 0.08,
  tds: 40,
  temperature: 22,
  alkalinity: 10,
  ca: 4,
  mg: 1,
  k: 0.5,
  na: 2,
  cl: 3,
  so4: 5,
  no3: 1,
  hco3: 12,
  co3: 0,
  createdAt: new Date('2025-05-10T15:45:00Z'),
  updatedAt: new Date('2025-05-10T15:45:00Z')
};

// RO water sample
export const roWaterSample: WaterQualityData = {
  id: '4',
  name: 'Reverse Osmosis Water',
  ph: 6.0,
  ec: 0.02,
  tds: 10,
  temperature: 20,
  alkalinity: 5,
  ca: 1,
  mg: 0.5,
  k: 0.2,
  na: 1,
  cl: 0.5,
  so4: 1,
  no3: 0.1,
  hco3: 6,
  co3: 0,
  createdAt: new Date('2025-05-05T09:15:00Z'),
  updatedAt: new Date('2025-05-05T09:15:00Z')
};
